export const GET_PRODUCTS = '[PRODUCT] GET_PRODUCTS';
export const UPDATE_CART_DATA = '[CART] UPDATE_CART_DATA';
export const EMPTY_CART = '[CART] EMPTY_CART';
export const ADD_TO_CART = '[CART] ADD_TO_CART';
export const REMOVE_FROM_CART = '[CART] REMOVE_FROM_CART';
export const DECREASE_COUNT_FROM_CART = '[CART] DECREASE_COUNT_FROM_CART';
export const GET_BLOGS = '[BLOG] GET_BLOGS';
export const GET_USER = '[USER] GET_USER';
export const SET_USER = '[USER] SET_USER';
export const SET_USER_ADDRESS = '[USER] SET_USER_ADDRESS';
export const REMOVE_USER = '[USER] REMOVE_USER';
export const SET_SHOW_ALL_NUM = '[NUM] SET_SHOW_ALL_NUM';